import { ACTION_TYPE } from '../../core/redux/actionType';
import { IAppState } from '../../core/redux/IAppState';
import { Action } from 'redux';
import { assoc } from '../../language/module';


/**
 * Makes an action you can dispatch to clear out the FAQ data in app state.
 */
export const clearReleaseNotesAction = () => ({
  type: ACTION_TYPE.CLEAR_RELEASE_NOTES,
});


export const clearReleaseNotesReducer = (
  state: IAppState,
  action: Action,
): IAppState => action.type !== ACTION_TYPE.CLEAR_RELEASE_NOTES ? state : assoc('releaseNotes', undefined, state);
